import React from 'react'
import ImageMapper from 'react-image-mapper'
import Aux from '../hoc/Auxiliary'
import NumberFormat from 'react-number-format'
import { getStatusColor } from '../utils/apartments'
import { getStatusColor as getParkingStatus } from '../utils/parking'
import { getTipTopPosition, getTipCenterPosition } from '../utils/interactiveMap'
import { withNamespaces } from 'react-i18next'

class InteractiveMap extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeArea: null
        }
    }
    enterArea(area) {
		this.setState({ activeArea: area });
	}
    leaveArea(area) {
		this.setState({ activeArea: null });
    }

    renderTooltipByMapType = (type, arr, area) => {
        const {width, imgWidth, t} = this.props
        let content
        switch(type) {
            case 'parking' : {
                let item
                if ( area.type === 'basement' ) {
                    item = arr.find(item => item.number === area.number)
                } else {
                    item = arr.find(item => item.id === parseInt(area.number,10))
                }
                content = {
                    styles: getTipTopPosition(this.state.activeArea, width, imgWidth),
                    name: <span className='u-text-uppercase'>{item.type} {item.number}</span>,
                    ...item.description ? { description: item.description } : {},
                    status: getParkingStatus(item.status),
                    price: item.taxPrice > 0 && <NumberFormat value={item.taxPrice} displayType={'text'} thousandSeparator={' '} prefix={`€`} />
                }
            }
            break;
            case 'apartment' : {
                const { floorNum } = this.props.match.params
                let item
                /**
                 * We have maisonette apartments that need to be distinguished from other apartments
                 * when displayed on the floor plans, so we added `type:'maisonette'` prop
                 * only to second floors of the apartments in coords objects. This way we calculate
                 * the right props of the apartment we should fetch.
                 *
                 * These props are used in `utils/redux/config/apartments` - coordsE['3']
                 */
                if ( area.type === 'maisonette'){
                    item = arr.find(item => item.number === parseInt(area.number, 10) && item.entranceUrl === area.entrance && item.floor === parseInt(floorNum-1, 10))
                } else {
                    item = arr.find(item => item.number === parseInt(area.number, 10) && item.entranceUrl === area.entrance && item.floor === parseInt(floorNum, 10))
                }
                content = {
                    styles: getTipCenterPosition(this.state.activeArea, width, imgWidth),
                    name: <span className='u-text-uppercase'>{item.type} {item.number}</span>,
                    status: getStatusColor(item.status),
                    area: item.grossArea,
                    price: <NumberFormat value={item.totalPrice} displayType={'text'} thousandSeparator={' '} prefix={`€`} />
                }
            }
            break;
            case 'homeschema': content = {
                styles: getTipCenterPosition(this.state.activeArea, width, imgWidth),
                name: area.title
            }
            break;
            default: {
                const { floorNum } = this.props.match.params
                let item
                if ( area.type === 'maisonette'){
                    item = arr.find(item => item.number === area.number && item.entranceUrl === area.entrance && item.floor === floorNum-1)
                } else {
                    item = arr.find(item => item.number === area.number && item.entranceUrl === area.entrance && item.floor === floorNum)
                }
                content = {
                    styles: getTipCenterPosition(this.state.activeArea, width, imgWidth),
                    name: <span className='u-text-uppercase'>{item.type} {item.number}</span>,
                    status: getStatusColor(item.status),
                    area: item.grossArea,
                    price: <NumberFormat value={item.totalPrice} displayType={'text'} thousandSeparator={' '} prefix={`€`} />
                }
            }
        }
        return <div className={`c-tooltip${ type === 'homeschema' ? ' c-tooltip--floor' : ''}`} style={{ ...content.styles}}>
            { content.status && <div className={`o-block u-text--tiny c-tooltip__header u-bg--${content.status.color}`}><span className='u-text-uppercase u-weight--bold'>{content.status.label}</span></div> }
            <div className={`u-text--small u-text--white c-tooltip__body${ type === 'homeschema' ? ' c-tooltip--floor__body' : ''}`}>
                <div className='o-block'>{content.name}</div>
                { content.description && <div className='o-block u-margin-top-tiny'>{content.description}</div> }
                { content.area && <div className='o-block u-margin-top-tiny'>{t('general.grossArea')}: <span className='u-text--mongoose'>{content.area} m<sup>2</sup></span></div> }
            </div>
        </div>
    }
    render () {
        const { url, name, areas, width, imgWidth, mapType, mapArray, onClickHandler } = this.props
        const map = {
            name,
            areas
        }
        return <Aux>
            <ImageMapper
                src={url}
                map={map}
                width={width}
                imgWidth={imgWidth}
                onMouseEnter={ area => this.enterArea(area)}
                onMouseLeave={ () => this.leaveArea()}
                onClick={ onClickHandler ? area => onClickHandler(area) : null}
                {...this.props}
                />
            { this.state.activeArea && this.renderTooltipByMapType(mapType, mapArray, this.state.activeArea) }
        </Aux>
    }
}

export default withNamespaces()(InteractiveMap)



// WEBPACK FOOTER //
// ./src/components/ImageMapper.js